<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import {
  qedk_initQedkInfo_api,
  qedk_infoPage_api,
  qedk_dataOriginInfoPage_api,
  qedk_updateLy_api,
  qedk_updateIinvoutData_api,
  qedk_clearNowTax_api,
  qedk_update_api,
  qedk_findDetails_api,
  qedk_fapiaoFind_api,
} from "@/api/qedk";
import config from "../../../../../configHttp";
export default {
  name: "qedk",
  components: {},
  data: function () {
    return {
      //查询和筛选
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      searchdiag: false,
      outlist: [],
      headData: getdata().headData,
      shaidiag: false,
      //主页面查询
      tableData: [{}],
      pagination: getdata().pagination,
      sort: "",
      order: "",
      //来源查询
      headlyData: getdata().headlyData,
      tablelyData: [],
      lypagination: getdata().lypagination,
      //手工登记
      formlist: getdata().formlist,
      formdata: getdata().formdata,
      headglData: getdata().headglData,
      tableglData: [
        {
          fapdm: "",
          faphm: "",
          kaiprq: "",
          weisje: "",
          shuie: "",
          isupdate: true,
        },
      ],
      sjlydiag: false,
      djdiag: false,
      suosq: this.$getdefultMonth(),
      backItem: {},
      deleteIds: [],
      tablekey: 0,
      overlength: 0,
    };
  },
  mounted() {
  },
  created() {
    this.init();
  },
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
    formxdj(row) {
      if (!row.sfyshenbao) {
        return;
      }
      this.detailsQuery(row);
    },
    sjlypz() {
      this.getDataOriginInfo();
    },
    closelydiag() {
      this.sjlydiag = false;
    },
    closediag() {
      this.djdiag = false;
    },
    foraddhang() {
      let isUpdate = this.tableglData.some((res) => res.isupdate == true);
      if (isUpdate) {
        this.$message.info("请先完成编辑状态中的行,再执行该操作");
        return;
      }
      this.tableglData.push({
        fapdm: "",
        faphm: "",
        kaiprq: "",
        weisje: "",
        shuie: "",
        isupdate: true,
      });
      this.backItem = {};
    },
    //批量更新取数 到时候可能做异步处理，所以和单个更新取数区分开来
    updateBatchData() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      if (selectVal.length == 0) {
        this.$message.info("请选中数据再进行更新取数操作");
        return;
      }
      let suosq = selectVal[0].suosq;
      let ids = new Array(selectVal.length);
      try {
        selectVal.forEach((v, k) => {
          if (v.shujly != 1) {
            throw new Error("只有数据来源为‘科目余额表’才能进行更新取数操作");
          }
          if (suosq != v.suosq) {
            throw new Error("只有相同所属期期才能进行批量更新取数");
          }
          ids[k] = v.id;
        });
      } catch (e) {
        this.$message.info(e.message);
        return;
      }
      this.updateQedkData(ids, suosq);
    },
    sizechangely(e) {
      this.lypagination.pageSize = e;
      this.getDataOriginInfo();
    },
    currentChangely(e) {
      this.lypagination.pageNum = e;
      this.getDataOriginInfo();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.getQedkInfo();
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.getQedkInfo();
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true
    },
    submitSearch() {
      this.getQedkInfo();
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    //单个更新取数
    updateSingleData(row) {
      if (!row.sfyshenbao) {
        return;
      }
      if (row.shujly != 1) {
        this.$message.info("只有数据来源为‘科目余额表’才能进行更新取数操作");
        return;
      }
      let ids = [row.id];
      this.updateQedkData(ids, row.suosq);
    },
    //更新取数
    updateQedkData(e, ssq) {
      let param = {
        ids: e,
        suosq: ssq,
      };
      qedk_updateIinvoutData_api(param).then((res) => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.getQedkInfo();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //页面多条件查询
    getQedkInfo() {
      //查询数据
      let params = this.searchdata;
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.order = 'asc';
      params.sort = 'id';
      qedk_infoPage_api(params).then((res) => {
        if (res.data.code == 1) {
          this.pagination.total = res.data.data.total;
          this.pagination.paginationkey++;
          this.tableData = res.data.data.records;
          this.jinyongpd();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //初始化数据
    init() {
      qedk_initQedkInfo_api({}).then((res) => {
        if (res.data.code != 1) {
          this.$message.error(res.data.msg);
        } else {
          this.suosq = res.data.data.suosq; //获取当前所属期yyyymm
          this.searchdata.suosq = this.$getdefultMonth(),
          this.getQedkInfo();
        }
      });
    },
    //按钮禁用判断
    jinyongpd() {
      this.tableData.forEach((res) => {
        res.sfydata = res.feiy ? true : false; //是否有转出数据
        res.sfyshenbao = res.suosqbz == "1" ? true : false; //是否是当前申报期
      });
    },
    getDataOriginInfo() {
      //查询数据
      let params = {};
      params.page = this.lypagination.pageNum;
      params.size = this.lypagination.pageSize;
      params.suosq = this.searchdata.suosq;
      qedk_dataOriginInfoPage_api(params).then((res) => {
        if (res.data.code != 1) {
          this.$message.error(res.data.msg);
        } else {
          this.lypagination.total = res.data.data.total;
          this.lypagination.paginationkey++;
          this.tablelyData = res.data.data.records;
          this.tablelyData.forEach((item) => {
            item.radiolist = this.$ShujlyMapping;
          });
        }
        this.sjlydiag = true;
      });
    },
    //导出列表
    downloadList() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let params = {
        pageShowListPojo: {},
      };
      if (selectVal.length < 1) {
        params.pageShowListPojo = this.searchdata;
        params.pageShowListPojo.order="asc";
        params.pageShowListPojo.sort="id";
        params.pageShowListPojo.current = this.pagination.pageNum;
        params.pageShowListPojo.size = this.pagination.pageSize;
      } else {
        let _ids = selectVal.map((item) => item.id);
        params.ids = _ids;
      }
      params.json = getdata().tableJson;
      this.fileDownload(params);
    },
    fileDownload(val) {
      let params = {
        downUrl: config.baseURL + "/qedk/list/export",
        typeObj: {
          toForm: false,
          fileType: "xlsx",
          fileName: "全额抵扣数据"+ this.$timestampToStr(new Date(), "yyyyMMdd"),
          failUrl:this.$winURl
        },
        params: val,
      };
      this.$downloadcommon(params);
    },
    //数据来源配置保存按钮
    saveDataOriginConfigButton() {
      this.$showConfirm({
        message:
          "切换数据来源，会清空当前纳税人下未申报成功的税款所属期已有数据（已申报成功的数据不受影响），是否继续？",
      }).then((res) => {
        if (res == "confirm") {
          this.saveDataOriginConfig();
        }
      });
    },
    //置为手工开票/置为科目余额表
    changeBatchShujlyButton(val) {
      let selectVal = this.$refs.tableboxly.getSelectionval();
      if (selectVal.length < 1) {
        this.$message.info("请选择数据再进行操作");
        return;
      }
      selectVal.forEach((item) => {
        item.laiy = val;
      });
    },
    //保存数据来源配置
    saveDataOriginConfig() {
      let param = this.tablelyData;
      qedk_updateLy_api(param).then((res) => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
        this.getQedkInfo();
        this.sjlydiag = false;
      });
    },
    //清空数据
    clearData(row) {
      if (!row.sfydata || !row.sfyshenbao) {
        return;
      }
      this.$showConfirm({
        message: "清空数据后当前税款所属期间内的所有数据将清除，是否确认操作？",
      }).then((res) => {
        if (res == "confirm") {
          this.clearNowTax(row);
        }
      });
    },
    clearNowTax(e) {
      let param = {
        id: e.id,
        suosq: e.suosq,
      };
      qedk_clearNowTax_api(param).then((res) => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.getQedkInfo();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //查询明细数据
    detailsQuery(e) {
      qedk_findDetails_api(e.id).then((res) => {
        if (res.data.code == 1) {
          this.formdata = JSON.parse(JSON.stringify(res.data.data)) ;
          console.log(this.formdata)

          this.tableglData = res.data.data.list;
          this.detailsBianjpd();
        } else {
          this.$message.error(res.data.msg);
        }
        this.djdiag = true;
      });
    },
    //按钮禁用判断
    detailsBianjpd() {
      this.tableglData.forEach((res) => {
        res.isupdate = false;
      });
    },
    //移除项
    removeItem(item, index) {
      if (item.id) {
        this.deleteIds.push(item.id); //删除的ids
      }
      this.tableglData.splice(index, 1);
    },
    //编辑项
    modifyOpen(item) {
      this.backItem = JSON.parse(JSON.stringify(item));
      item.isupdate = true;
      var newdata = JSON.parse(JSON.stringify(this.tableglData));
      this.tableglData = newdata;
    },
    //保存项
    saveItem(item) {
      if (!item.fapdm) {
        this.$message.info("请填写发票代码");
        return;
      }
      if (!item.faphm) {
        this.$message.info("请填写发票号码");
        return;
      }
      this.backItem = {};
      item.isupdate = false;
    },
    //取消编辑
    cancelItem(item, index) {
      if (!this.backItem.fapdm && !this.backItem.faphm) {
        this.tableglData.splice(index, 1);
        return;
      }
      this.item = false;
      this.backItem.isupdate = false;
      this.tableglData[index] = JSON.parse(JSON.stringify(this.backItem));
      var newdata = JSON.parse(JSON.stringify(this.tableglData));
      this.tableglData = newdata;
    },
    getdata(row) {
      let params = JSON.parse(JSON.stringify(row));
      params.deleteIds = this.deleteIds;
      params.list = this.tableglData;
      qedk_update_api(params).then((res) => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.getQedkInfo();
          this.djdiag = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    saveFapDetails() {
      let isUpdate = this.tableglData.some((res) => res.isupdate == true);
      if (isUpdate) {
        this.$message.info("请先完成编辑状态中的行,再执行该操作");
        return;
      }
      this.$refs.taxform.submitForm();
    },
    blurFapiao(row) {
      if (!row.fapdm || !row.faphm) {
        return;
      }
      if (
        row.fapdm.length < 10 ||
        row.fapdm.length > 20 ||
        row.faphm.length < 8 ||
        row.faphm.length > 12
      ) {
        return;
      }
      let params = {
        fapdm: row.fapdm,
        faphm: row.faphm,
      };
      qedk_fapiaoFind_api(params).then((res) => {
        if (res.data.code == 1) {
          row.shuie = res.data.data.shuiehj;
          row.kaiprq = res.data.data.kaiprq;
          row.weisje = res.data.data.weisje;
          var newdata = JSON.parse(JSON.stringify(this.tableglData));
          this.tableglData = newdata;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
